import { createEffect } from "solid-js"
import { BufferGeometry, CameraHelper, DirectionalLight, Line, LineBasicMaterial, Vector3 } from "three"
import createSharedCachedFactory from "../../../rx/memo/createSharedCachedFactory"
import type { Engine } from "../../core/engine/Engine.type"
import { max, sqrt } from "../../core/util/math/Math"
import { VERTICES_PER_TILE } from "../consts"
import useMainScene from "../fn/useMainScene"

// const SHADOW_MAP_SIZE = 256
// const SHADOW_MAP_SIZE = 2048
const SHADOW_MAP_SIZE = 4096
// const SHADOW_MAP_SIZE = 40960

const SHOW_DEBUG_MARKERS = false

export const useSharedDirectionalLight = createSharedCachedFactory((
  engine: Engine,
) => {
  // const directionalLight = new DirectionalLight(0xffe08a, 2)
  const directionalLight = new DirectionalLight(0xffffff, 1.0)
  directionalLight.castShadow = true // Enable shadows
  const { shadow } = directionalLight
  shadow.mapSize.set(SHADOW_MAP_SIZE, SHADOW_MAP_SIZE)
  const shadowCamera = shadow.camera
  shadow.radius = 4
  shadow.blurSamples = 20
  shadow.bias = -0.0001
  shadow.normalBias = 0.05

  let debugLine: Line | null = null

  const center = new Vector3()

  if (SHOW_DEBUG_MARKERS) {
    const scene = useMainScene(engine)
    const directionalLightShadowHelper = new CameraHelper(directionalLight.shadow.camera)
    directionalLight.add(directionalLightShadowHelper)

    const lineGeometry = new BufferGeometry().setFromPoints(getDebugLinePoints(directionalLight))
    const lineMaterial = new LineBasicMaterial({ color: 0xffffff })
    debugLine = new Line(lineGeometry, lineMaterial)
    scene.add(debugLine)
    console.log('scene', scene)
  }

  createEffect(() => {
    // console.log('useSunDirectionalLight.effect')
    const { width, height } = engine.state
    if (width === 1 || height === 1) {
      return
    }

    const mapWidthWorld = width * VERTICES_PER_TILE
    const mapHeightWorld = height * VERTICES_PER_TILE
    const mapSizeWorld = max(mapWidthWorld, mapHeightWorld)
    const mapDiagonalWorld = sqrt((mapWidthWorld ** 2) + (mapHeightWorld ** 2))

    center.set(mapWidthWorld / 2, 0, mapHeightWorld / 2)

    shadowCamera.left = -mapSizeWorld * 2
    shadowCamera.right = mapSizeWorld * 2
    shadowCamera.top = mapSizeWorld * 2
    shadowCamera.bottom = -mapSizeWorld * 2
    shadowCamera.near = 0
    shadowCamera.far = 4 * mapDiagonalWorld

    directionalLight.position.set(
      (mapWidthWorld * -0.1),
      mapDiagonalWorld * 0.5,
      (mapHeightWorld * -0.1))
    directionalLight.target.position.copy(center)

    directionalLight.updateMatrixWorld()
    shadowCamera.updateProjectionMatrix()
    shadowCamera.updateMatrixWorld()

    if (SHOW_DEBUG_MARKERS && debugLine) {
      debugLine.geometry.setFromPoints(getDebugLinePoints(directionalLight))
    }
  })

  // createMountedInverval(() => {
  //   // directionalLight.visible = !directionalLight.visible
  //   directionalLight.intensity = directionalLight.intensity === 1 ? 2 : 1
  // }, 1000)

  // directionalLight.visible = false
  directionalLight.castShadow = false

  return directionalLight
})

function getDebugLinePoints(directionalLight: DirectionalLight) {
  const pointA = directionalLight.position
  const pointB = directionalLight.target.position
  const points = [pointA, pointB]
  return points
}